import {
  Button,
  CardActions,
  CardContent,
  CardMedia,
  Card,
  LinearProgress,
} from "@mui/material";

import React, { useEffect } from "react";
import { MdEventSeat } from "react-icons/md";

import { useNavigate } from "react-router-dom";
import Constants from "../data/Constants";
import moment from "moment";
import { BsArrowBarRight, BsArrowReturnLeft } from "react-icons/bs";
import { TbCircleCheck } from "react-icons/tb";

function ClassCard(props) {
  const { courseClass, hideActionBar, onClick, id } = props;

  var lastSession;
  var lastSessionTime = -1;

  var totalCompletedSessions = 0;

  for (let session of courseClass.sessions) {
    var time = moment(session.time);
    let mins = time.diff(moment(), "minutes");

    if (mins < 0) {
      totalCompletedSessions++;
      continue;
    }

    if (lastSessionTime == -1) {
      lastSession = session;
      lastSessionTime = mins;
      continue;
    }

    if (lastSessionTime > mins) {
      lastSession = session;
      lastSessionTime = mins;
    }
  }

  const navigate = useNavigate();

  const viewHandler = (e) => {
    // navigate("/dashboard/course/view/" + course._id, {
    //   state: { course: course },
    // });
  };

  const editHandler = (e) => {
    // navigate("/dashboard/courses/edit/" + course._id);
  };

  return (
    courseClass && (
      <Card
        sx={{ width: "300px" }}
        className={props.className}
        onClick={onClick}
      >
        <CardMedia
          component="img"
          className="object-cover"
          style={{ height: "150px" }}
          image={courseClass.course.cover.url}
        />

        <CardContent>
          <div className="text-lg font-bold text-ellipsis truncate">
            {courseClass.course.name}
          </div>
          <div className="text-sm">{courseClass.course.type}</div>
          <div className="flex gap-4 items-center text-ellipsis truncate text-gray-600 text-sm">
            <div>Batch {courseClass.batchNumber}</div>
            <div className="flex gap-1 items-center">
              <MdEventSeat size={18} />
              <span className="text-no">
                {courseClass.bookedSeats + "/" + courseClass.totalSeats}
              </span>
            </div>
          </div>
          <div className="text-sm my-2">
            <LinearProgress
              variant="determinate"
              value={
                (totalCompletedSessions / courseClass.sessions.length) * 100
              }
            />
            {totalCompletedSessions} of {courseClass.sessions.length} sessions
          </div>

          {lastSession ? (
            <div className="bg-secondary p-2 my-2 rounded-sm text-sm flex items-center gap-2 font-bold">
              <BsArrowBarRight className="" size={20} />

              <div className="font-normal">
                <span className="font-bold">
                  {lastSession.topic.name + " "}
                </span>

                {moment(lastSession.time).fromNow()}
              </div>
            </div>
          ) : (
            <div className="bg-green-200 p-2 my-2 rounded-sm text-sm flex items-center gap-2 font-bold">
              <TbCircleCheck className="" size={20} />
              All Sessions Completed
            </div>
          )}
        </CardContent>
      </Card>
    )
  );
}

export default ClassCard;
